import { defineComponent as _defineComponent } from 'vue'
import {
  PropType, Ref, ref, onMounted, watch, computed,
} from 'vue';

import { StripeElements, StripeError } from '@stripe/stripe-js';
import { Customer, Invoice } from '@/api/api-billing';
import activityIndicator from '@/plugins/activity-indicator-plugin/activity-indicator';
import { actionShowError } from '@/services/vue-utils';
import { createPaymentElements } from '@/services/payment-details-utils';
import { useVuetify } from '@/components/helpers/vue2-helpers';

export interface PaymentElementsCompleteEvent {
  elements: StripeElements;
  paymentMethodType: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentElement',
  props: {
  clientSecret: { type: Object as PropType<string|undefined>, required: false, default: undefined },
  invoice: { type: Object as PropType<Invoice|undefined>, required: false, default: undefined },
  customer: { type: Object as PropType<Customer|undefined>, required: true },
  disallowInactive: { type: Boolean as PropType<boolean>, required: false, default: false },
},
  emits: ["complete"],
  setup(__props, { emit }: { emit: ({(e: 'complete', event: PaymentElementsCompleteEvent | undefined): void}), expose: any, slots: any, attrs: any }) {

const props = __props;

const vuetify = useVuetify();





function handleError(error: StripeError) {
  actionShowError(new Error(error.message));
}

let elements: StripeElements | undefined;

const destroy = async () => {
  if (!elements) return;

  const paymentElement = elements.getElement('payment');
  if (!paymentElement) return;

  paymentElement.unmount();
  paymentElement.destroy();
};

const paymentElementFocused = ref(true);

const incactive = computed(() => !paymentElementFocused.value && !props.disallowInactive);

const create = async () => {
  destroy();

  // create elements
  activityIndicator.show();
  const { customer, clientSecret, invoice } = props;
  const darkTheme = vuetify.theme.dark;
  elements = await createPaymentElements({
    customer, clientSecret, invoice, darkTheme,
  });
  activityIndicator.hide();

  const paymentElement = elements?.getElement('payment');
  if (!paymentElement) {
    return;
  }

  // setup elements
  paymentElement.on('loaderstart', (event) => {
    activityIndicator.show();
  });
  paymentElement.on('loaderror', (event) => {
    activityIndicator.hide();
    handleError(event.error);
  });
  paymentElement.on('ready', async (event) => {
    activityIndicator.hide();
    paymentElement.focus();
  });

  // latest 'change' values
  let paymentMethodType: string | undefined;
  let complete: boolean | undefined;

  paymentElement.on('change', (event) => {
    // remember latest 'change' values
    paymentMethodType = event.value.type;
    complete = event.complete;
    const e = complete && paymentMethodType && elements ? { elements, paymentMethodType } : undefined;
    emit('complete', e);
  });

  paymentElement.on('blur', (event) => {
    console.log('payment element blur: ', event);
    paymentElementFocused.value = false;
  });
  paymentElement.on('focus', (event) => {
    console.log('payment element focus: ', event);
    paymentElementFocused.value = true;
    // use latest 'change' values
    const e = complete && paymentMethodType && elements ? { elements, paymentMethodType } : undefined;
    emit('complete', e);
  });

  // mount elements
  paymentElement.mount('#payment-element');
};

watch(
  () => props.clientSecret,
  (value, oldValue) => { if (value !== oldValue) create(); },
);

onMounted(async () => create());


return { __sfc: true,vuetify, props, emit, handleError, elements, destroy, paymentElementFocused, incactive, create }
}

})